<template>
<hic-dialog append-to-body @open="open" :close-on-click-modal="false" :visible="visible" width="70rem" top="10vh" :title="title" @close="close"> 
  <el-row type="flex">
      <el-col :span="2" class="ftbw font16" :offset="1">{{patientInfo.patientName}}</el-col>
      <el-col :span="2">{{patientInfo.patientGender | dictText('Gender')}} {{patientInfo.patientAge}}</el-col>
      <el-col :span="4">{{patientInfo.ipNo}}</el-col>
      <el-col :span="4">入院诊断：{{patientInfo.diagnosisName}}</el-col>
      <el-col :span="6">入院时间：{{patientInfo.startDate}}</el-col>
    </el-row>
    <el-row v-if="title=='入科'" type="flex" class="mtop15 center">
      <el-col :span="4"></el-col>
      <el-col :span="4">转出科室：{{$utils.Dict.text(patientInfo.deptCode, "Dept")}}</el-col>
    </el-row>
    <br/>
    <div style="border-bottom:1px solid #DCDFE6;"></div>
    <br/>
    <el-form v-loading="meta.loading" class="left" style="padding:0 50px;" ref="info" :rules="rules" :inline="true" :model="patientInfo" @submit.native.prevent label-width="7rem">
      <div v-if="title=='转科'">
        <el-row type="flex">
          <el-col>
            <el-form-item label="转入科室：" prop="transferTargetCode">
              <hic-dict-selector dict-type="Dept" v-model="patientInfo.transferTargetCode" placeholder="请选择转入科室"/>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="title=='入科'">
        <el-row type="flex">
          <el-col>
            <el-form-item label="责任护士：" prop="nurseId">
              <hic-staff-selector :name="patientInfo.nurseId+''" v-model="patientInfo.nurseId"/>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="主治医师：" prop="masterId">
              <hic-staff-selector :name="patientInfo.masterId+''" v-model="patientInfo.masterId"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="">
          <el-col>
            <el-form-item label="住院病区：" prop="wardCode">
              <hic-dict-selector v-model="patientInfo.wardCode" dict-type="IpWard" />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="护理等级：" prop="nursingGrade">
              <hic-dict-selector v-model="patientInfo.nursingGrade" dict-type="CriticalLevel"  is-enum  />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="">
          <el-col>
            <el-form-item label="入科时间：" prop="checkinDate">
              <el-date-picker size="small" style="width:210px;" readonly="" v-model="patientInfo.checkinDate" type="datetime" placeholder="选择入科时间"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="">
          <el-col>
            <el-form-item label="床位选择：" prop="bedId">
              <el-input style="width:200px;display:none !important" v-model="patientInfo.bedId" ></el-input>
              <el-button type="primary" size="small" @click="meta.showBed = true" style="width:100px;">选择</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="title=='入科'">
        <bedTable :ipNo="patientInfo.ipNo" :patientCode="patientInfo.patientCode" :bedList="bedList"></bedTable>
      </div>
    </el-form>  
    <BedSelector :hospitalization="patientInfo" :visible.sync="meta.showBed" @selected="getBed" />
    <!-- <appendBed :visible.sync="meta.showBed" :info="patientInfo" type="入科" @getBed="getBed"></appendBed> -->
    <div slot="footer">
      <el-row style="margin-top: 20px; text-align: right">
        <el-button type="info" size="large" @click.native="$emit('update:visible', false)" style="margin-right: 1rem">关闭</el-button>
        <el-button :loading="meta.loading" @click="submit"  style="margin-right: 1rem" type="primary"  size="large">提交</el-button>
      </el-row>
    </div>
    
  </hic-dialog>
</template>

<script>
import api from "./api";
// import utils from "@/common/utils";
import { mapGetters } from "sw-hic";
export default {
  components: {
    bedTable: () => import("@/components/bed/bedTable.vue"),
    // appendBed: () => import("@/components/bed/dlgBedSelector.vue"),
  },
  props: {
    title:{
      type: String,
      default: '入科'
    },
    visible: Boolean,
    infoDetail:Object
  },
  data() {
    return {
      selIndex:0,
      meta:{
        loading:false,
        showBed:false
      },
      patientInfo:{
        checkinDate:""
      },
      rules: {
        transferTargetCode: [{ required: true, message: "请选择转入科室", trigger: "change" },],
        nurseId: [{ required: true, message: "请选择转责任护士", trigger: "change" },],
        masterId: [{ required: true, message: "请选择转主治医师", trigger: "change" },],
        wardCode: [{ required: true, message: "请选住院病区", trigger: "change" },],
        nursingGrade: [{ required: true, message: "请选择护理等级", trigger: "change" },],
        checkinDate: [{ required: true, message: "请选择入科时间", trigger: "change" },],
        bedId: [{ required: true, message: "请选择床位", trigger: "change" },],
      },
      bedList:[],
      info:{}
    };
  },
  computed: {
    ...mapGetters(["dict", , "Enum", "dictEnum","user"])
  },
  filters:{
  },
  watch:{
  },
  mounted() {
    if(this.title=='入科'){
    }else{//转科
      
    }
  },
  methods: {
    open(){
      this.bedList = []
      this.patientInfo = JSON.parse(JSON.stringify(this.infoDetail))
      this.patientInfo.checkinDate = this.$utils.Fmt.datetime(new Date())
    },
    getBed(bed){
      this.$utils.log('选择的床位==='+JSON.stringify(bed))
      this.patientInfo.bedId = bed.id
      this.patientInfo.bedNo = bed.no
      this.bedList = [bed]
    },

    close() {
      this.$emit("update:visible", false);
    },
    // async getHasBed(){
    //   let blist = await api.listByIpNo(this.patientInfo.ipNo)
    //   blist.forEach(element => {
    //     element.children = [
    //       {
    //         name:"add"
    //       }
    //     ]
    //     element.hasChildren = true
    //   });
    //   this.wrapBedList = blist
    // },
    // load(tree, treeNode, resolve){
    //   console.log('tree',tree)
    //   console.log('treeNode',treeNode)
    // },
    // async getBedList(){
    //   try {
    //     // 查询
    //     // this.meta.loading = true;
    //     if(!this.ifExtra){
    //       this.condition.ifExtra = this.ifExtra
    //     }else{
    //       this.condition.ifExtra = null
    //     }
    //     api.getEmptyList(this.condition).then((res)=>{
    //       this.bedList = res
    //     }).catch((err)=>{
    //       this.$message.error(err.message || err);
    //     }).finally(()=>{
    //       this.meta.loading = false;
    //     }) 
    //   } catch (err) {
    //     if (err && err != "cancel") {
    //       console.log(err);
    //       this.$message.error(err.message || err);
    //     }
    //   } 
    // },
    submit(){
      this.$refs.info.validate((valid) => {
        if (valid) {
          this.meta.loading = true
          if(this.title == '出科'){
            api.Hospitalization.checkout(this.patientInfo.id,this.patientInfo).then((res)=>{
              this.$message.success("设置出科成功")
              this.$emit("close");
              this.close()
            }).catch((err)=>{
              this.$message.error(err.message || err);
            }).finally(()=>{
              this.meta.loading = false;
            }) 
          }else{
            api.Hospitalization.checkin(this.patientInfo.id,this.patientInfo).then((res)=>{
              this.addFeeItemToBed(this.bedList[0].id,this.bedList[0].children)
              
            }).catch((err)=>{
              this.$message.error(err.message || err);
            }).finally(()=>{
              this.meta.loading = false;
            }) 
          }
        } else {
          console.log("error submit!!");
        }
      })
    },
    addFeeItemToBed(bedId,flist){
      if(flist.length > 0 && flist[0].name != 'add'){
        let _pra = {
          bedId,
          chargeCode:flist[0].code
        }
        flist.shift()
        this.meta.loading = true
        api.BedFee.save(_pra).then(res=>{
          this.addFeeItemToBed(bedId,flist)
        }).catch(error=>{
          this.meta.loading = false
        })
      }else{
        this.$message.success("设置入科成功")
        this.$emit("close");
        this.close()
      }
      
    },
    // changeKe(){
    //   if(!this.mainId){
    //     return this.$message.error('请选择调用的床位')
    //   }
    //   this.meta.loading = true
    //   api.changeMainBed(this.patientInfo.bedId,this.mainId).then(res=>{
    //     this.$message.success('调换床位成功')
    //     setTimeout(()=>{
    //       this.getHasBed()
    //       this.getBedList()
    //     },300)
        
    //   }).catch(error=>{
    //     this.$message.error('调换床位失败')
    //   }).finally(()=>{
    //     this.meta.loading = false
    //   })
    // },
    // async warpBed(){
    //   if(this.unionBedIds.length == 0){
    //     return this.$message.error('请选择要包的床位')
    //   }
    //   this.meta.loading = true
    //   let params = {
    //     patientCode:this.patientInfo.patientCode,
    //     ipNo:this.patientInfo.ipNo,
    //     ifWrapped:true,
    //     startTime:this.patientInfo.startDate,
    //     endTime:this.patientInfo.endDate,
    //     type:0 //0:入院（包床）1：转科
    //   }
    //   for(var i = 0;i<this.unionBedIds.length;i++){
    //     params.bedId = this.unionBedIds[i]
    //     let res = await api.addBedLog(params)
    //     console.log(i+'==',res)
    //   }
    //   // this.meta.loading = false
    //   this.$message.success('包床成功')
    //   this.getHasBed()
    //   this.getBedList()
    // },
    handleClick(){}
  },
};
</script>